import React, { useContext } from "react"
import { useToggle } from "../../../utils/Hooks"
import { useFormContext } from "react-hook-form"
import { Form } from "../../views/atoms/forms/Form"
import { Label, Spacer } from "../../views/atoms/Atoms"
import { ArrowLink } from "../../views/atoms/links/ArrowLink"
import { ButtonPrimary } from "../../views/atoms/buttons/ButtonPrimary"
import { FormSingleSelect } from "../../views/atoms/forms/FormSingleSelect"
import { CompleteFormTextArea } from "../../views/atoms/forms/FormTextArea"
import { CompleteFormInput } from "../../views/atoms/forms/FormInput"
import { SendMessageContext } from "../TalkToCarrotSendMessage"
import UpdateYourContactModal from "../../views/modal/UpdateYourContactModal"
import MessageReceivedModal from "../../views/modal/MessagReceivedModal"
import { Text, OptionComponent } from "@carrotfertility/carotene"

const TalkToCarrotSendMessageForm = () => {
  const { sent, personalEmail, employeeEmail, partnerEmail, sentFromPartnerEmail } = useContext(SendMessageContext)
  const [showMessageReceivedModal, toggleShowMessageReceivedModal] = useToggle(true)

  return (
    <>
      <SendMessageFormBody />
      {sent && showMessageReceivedModal && (
        <MessageReceivedModal
          onExit={toggleShowMessageReceivedModal}
          personalEmail={personalEmail}
          employeeEmail={employeeEmail}
          partnerEmail={partnerEmail}
          sentFromPartnerEmail={sentFromPartnerEmail}
        />
      )}
    </>
  )
}

const SendMessageFormBody = () => {
  const { onSubmit } = useContext(SendMessageContext)

  return (
    <>
      <Form onSubmit={onSubmit}>
        <SendMessageEmailInput />
        <MessageTextArea />
        <ButtonFooter />
      </Form>
    </>
  )
}

const UpdateContactInfoModalLink = () => {
  const [showUpdateContactInfoModal, toggleShowUpdateContactInfoModal] = useToggle(false)

  return (
    <>
      <ArrowLink onClickOnly onClick={toggleShowUpdateContactInfoModal}>
        {`Update your contact info`}
      </ArrowLink>
      {showUpdateContactInfoModal && <UpdateYourContactModal onExit={toggleShowUpdateContactInfoModal} />}
    </>
  )
}

const EmailInput = ({ showUpdateContactInfo }) => {
  const { errors, setValue, register } = useFormContext()
  const { partnerEmail, options } = useContext(SendMessageContext)
  const defaultEmail = partnerEmail ? null : options[0].id
  setValue("email", defaultEmail)
  return (
    <CompleteFormInput
      name={"email"}
      value={defaultEmail}
      label={`Your Email`}
      rightLabel={showUpdateContactInfo && <UpdateContactInfoModalLink />}
      errors={errors}
      disabled
      ref={register}
    />
  )
}
const SendMessageEmailInput = ({ showUpdateContactInfo = true }) => {
  const { partnerEmail } = useContext(SendMessageContext)

  return (
    <>
      {partnerEmail ? (
        <EmailDropdown showUpdateContactInfo={showUpdateContactInfo} />
      ) : (
        <EmailInput {...{ showUpdateContactInfo }} />
      )}
    </>
  )
}

const Option = (props) => {
  return (
    <OptionComponent {...props}>
      <Text marginRight="tiny"> {props.label} </Text>
      <Text variant="subtext">{props.data.subLabel}</Text>
    </OptionComponent>
  )
}

const EmailDropdown = ({ showUpdateContactInfo }) => {
  const { options } = useContext(SendMessageContext)
  const { setValue, errors } = useFormContext()

  return (
    <>
      <div className="flex justify-between">
        <Label valid={true} htmlFor={"email"}>{`Your Email`}</Label>
        {showUpdateContactInfo && <UpdateContactInfoModalLink />}
      </div>
      <Spacer height={0.5} />
      <FormSingleSelect
        name={"email"}
        rules={{ required: "Please select an email" }}
        {...{ setValue, errors, options, optionComponent: Option }}
      />
    </>
  )
}

const MessageTextArea = ({ showPlaceholderText = true, rows = "8" }) => {
  const { register, errors } = useFormContext()

  return (
    <CompleteFormTextArea
      ref={register({ required: "Please enter a message" })}
      errors={errors}
      label="message"
      name="message"
      placeholder={showPlaceholderText && "Type your message here..."}
      rows={rows}
    />
  )
}

const ButtonFooter = () => {
  const { onSubmit } = useContext(SendMessageContext)
  const {
    formState: { isValid, isSubmitting }
  } = useFormContext()

  return (
    <div className="flex flex-row justify-end">
      <ButtonPrimary onClick={onSubmit} enabled={isValid && !isSubmitting} disabledBackgroundColor="black-10">
        {isSubmitting ? "Sending ..." : "Send"}
      </ButtonPrimary>
    </div>
  )
}

export { TalkToCarrotSendMessageForm }
